import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogCiius from './EditCatalogCiius'
import ListCatalogCiius from './ListCatalogCiius'
import NewCatalogCiius from './NewCatalogCiius'

const AdminCatalogCiiusRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogCiius /></PrivateRoute7>} />
        <Route path="edit-ciiu" element={<PrivateRoute7><EditCatalogCiius /></PrivateRoute7>} />
        <Route path="new-ciiu" element={<PrivateRoute7><NewCatalogCiius /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogCiiusRoutes